module.exports = __webpack_public_path__ + "img/death.d2c8c168.svg";